import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { Main } from '../../../layouts';
import Container from '../../Container';
import OnGoingTours from "./Discover/OngoingToursContainer";
import MostLikedTours from "./Discover/MostLikedToursContainer";

export default function DiscoverPage() {
    const theme = useTheme();
    const mode = theme.palette.mode;

    return (
        <React.Fragment>
                <Typography
                    sx={{
                        textTransform: 'uppercase',
                        fontWeight: 500,
                        letterSpacing: 1,
                    }}
                    gutterBottom
                    color="text.secondary"
                >
                    Open Travel Community
                </Typography>

                <Box mb={2}>
                    <Typography
                        variant="h3"
                        component="h2"
                        color="text.primary"
                        fontWeight={700}
                        lineHeight={1.2}
                    >
                        Entdecke die{' '}
                        <Typography
                            component="span"
                            variant="inherit"
                            color="text.primary"
                            sx={{
                                background: `linear-gradient(180deg, transparent 82%, ${alpha(
                                    mode === 'light'
                                        ? theme.palette.secondary.main
                                        : theme.palette.primary.main,
                                    0.3
                                )} 0%)`,
                            }}
                        >
                            Lieblingsreisen der Community
                        </Typography>
                    </Typography>
                    <Box mt={2}>
                        <Typography variant="h6" color="text.secondary">
                            Schau dir an, welche Reisen in der Community besonders beliebt sind –
                            oder entdecke, wer gerade unterwegs ist.
                        </Typography>
                    </Box>
                </Box>

                <Box mb={5}>
                    <Typography variant="h5" sx={{ mb: 1 }}>
                        Beliebte Reisen
                    </Typography>
                    <Box sx={{ width: '100%', mx: 'auto' }}>
                        <MostLikedTours />
                    </Box>
                </Box>

                <Box mb={5}>
                    <Typography variant="h5" sx={{ mb: 1 }}>
                        Aktuell unterwegs
                    </Typography>
                    <Box sx={{ width: '100%', mx: 'auto' }}>
                        <OnGoingTours />
                    </Box>
                </Box>
        </React.Fragment>
    );
}
